module.exports = __webpack_public_path__ + "media/Hilfevideo_LBST_Stempeln.1dbc198f.mp4";